/**
 * Narrow Products dropdown for the chocolate header.
 * Hover/click disclosure; no size/qty/price UI here.
 */
if (!customElements.get('crisp-products-menu')) {
  class CrispProductsMenu extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.crisp-products__panel');
      this.trigger = this.querySelector('.crisp-products__disclosure, .crisp-products__pill');
      this.closeTimer = null;
      this.onDocClick = this.onDocClick.bind(this);
      this.onKey = this.onKey.bind(this);
      this.onEnter = this.onEnter.bind(this);
      this.onLeave = this.onLeave.bind(this);

      this.trigger?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.toggle();
      });

      this.addEventListener('mouseenter', this.onEnter);
      this.addEventListener('mouseleave', this.onLeave);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('keydown', this.onKey);
      this.removeEventListener('mouseenter', this.onEnter);
      this.removeEventListener('mouseleave', this.onLeave);
    }

    get canHover() {
      return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }

    onEnter() {
      if (!this.canHover) return;
      clearTimeout(this.closeTimer);
      this.open();
    }

    onLeave() {
      if (!this.canHover) return;
      this.scheduleClose();
    }

    scheduleClose() {
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => this.close(), 140);
    }

    toggle() {
      if (this.isOpen) this.close();
      else this.open();
    }

    get isOpen() {
      return this.trigger?.getAttribute('aria-expanded') === 'true';
    }

    open() {
      document.querySelectorAll('crisp-products-menu').forEach((el) => {
        if (el !== this) el.close();
      });
      clearTimeout(this.closeTimer);
      this.trigger?.setAttribute('aria-expanded', 'true');
      this.panel?.removeAttribute('hidden');
      document.addEventListener('click', this.onDocClick);
      document.addEventListener('keydown', this.onKey);
    }

    close() {
      clearTimeout(this.closeTimer);
      this.trigger?.setAttribute('aria-expanded', 'false');
      this.panel?.setAttribute('hidden', '');
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('keydown', this.onKey);
    }

    onDocClick(event) {
      if (this.contains(event.target)) return;
      this.close();
    }

    onKey(event) {
      if (event.key === 'Escape') {
        this.close();
        this.trigger?.focus();
      }
    }
  }

  customElements.define('crisp-products-menu', CrispProductsMenu);
}
